import script from "./VInputImage.vue?vue&type=script&setup=true&lang=js"
export * from "./VInputImage.vue?vue&type=script&setup=true&lang=js"

import "./VInputImage.vue?vue&type=style&index=0&id=7a8ac129&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a8ac129"]])

export default __exports__